"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInventoryArticle = exports.PricedInventoryArticle = void 0;
var InventoryArticle_1 = require("./InventoryArticle");
var PricedInventoryArticle = /** @class */ (function (_super) {
    __extends(PricedInventoryArticle, _super);
    function PricedInventoryArticle(params) {
        var _this = _super.call(this, params) || this;
        _this.priceReport = params.priceReport;
        return _this;
    }
    PricedInventoryArticle.prototype.toPlainObject = function () {
        return __assign(__assign({}, _super.prototype.toPlainObject.call(this)), { priceReport: this.priceReport });
    };
    return PricedInventoryArticle;
}(InventoryArticle_1.InventoryArticle));
exports.PricedInventoryArticle = PricedInventoryArticle;
function createInventoryArticle(params) {
    //@ts-ignore
    if (params.priceReport) {
        //@ts-ignore
        return new PricedInventoryArticle(params);
    }
    else {
        return new InventoryArticle_1.InventoryArticle(params);
    }
}
exports.createInventoryArticle = createInventoryArticle;
//# sourceMappingURL=PricedInventoryArticle.js.map